export default __webpack_public_path__ + "assets/models/3d20bd8ea1a0b86d912c611dba20d356.glb";